import { render } from "./Nopermission.vue?vue&type=template&id=e8d561fc&scoped=true"
const script = {}

import "./Nopermission.vue?vue&type=style&index=0&id=e8d561fc&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d561fc"]])

export default __exports__